import React from "react";
import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";
import DGU_Glass_Banner from "../../../Assets/Product_Images/DGUglass/DGU_Glass_Banner.webp";
import DGU_Glass_1 from "../../../Assets/Product_Images/DGUglass/DGU_Glass_1.webp";
import DGU_Glass_2 from "../../../Assets/Product_Images/DGUglass/DGU_Glass_2.webp";
import DGU_Glass_3 from "../../../Assets/Product_Images/DGUglass/DGU_Glass_3.webp";
import { Link } from "react-router-dom";

const DGU_Glass = () => {
  return (
    <div>
    <Header />
    {/* banner section start  */}
    <section
      className="container-fluid common_banner"
      style={{
        backgroundImage: `url(${DGU_Glass_Banner})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="common_title wow fadeInUp">
              <h2>
                <Link
                  to="/AboutUs"
                  className="text-decoration-none text-white"
                >
                  ABOUT US 
                </Link>{" "}
                / <span className="text-white">DGU Glass</span>
              </h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* banner section end */}

    {/* about tabbing section start  */}
    <section className="container-fluid about_Products_section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="blog_text wow fadeInUp">
              <h5 style={{ color: "#153fa4", fontFamily: "Segoe UI, sans-serif", fontSize: "40px", fontWeight: "700", marginBottom: "15px" }}>DGU Glass (Double Glazed Unit Glass)</h5>
              <p>
              Double-glazed unit glass (DGU) is two panes of glass sealed to create a single unit spaced apart by a spacer. To enhance thermal performance, the space between the panes is sometimes filled with air or inert gas such as argon. Widely found in windows and doors to offer great insulation and energy economy, this kind of glass is
              </p>
              <p>
              DGU glass's key benefit is that it lowers energy costs by minimizing heat transfer, therefore lessening the need for heating or cooling. It also provides great sound insulation, which makes it perfect for urban settings where noise cancellation takes top priority. Low-E and other coatings enable DGU glass to significantly improve both its thermal and optical qualities.
              </p>
              <p>
              DGU glass's key benefit is that it lowers energy costs by minimizing heat transfer, therefore lessening the need for heating or cooling. It also provides great sound insulation, which makes it perfect for urban settings where noise cancellation takes top priority. Low-E and other coatings enable DGU glass to significantly improve both its thermal and optical qualities.
              </p>

              
            </div>
            <div className="Products_img gap-5 mt-5 wow fadeInUp">
              <img src={DGU_Glass_1} style={{width : "250px" , height : "250px"}} alt="Bus" />
              <img src={DGU_Glass_2} style={{width : "250px" , height : "250px"}} alt="car" />
              <img src={DGU_Glass_3} style={{width : "250px" , height : "250px"}} alt="car" />
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* about tabbing section End */}

    <Footer />
  </div>
  )
}

export default DGU_Glass
